import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const beneficiaries: AnswerPathTreeNode = { path: 'beneficiaries', nodeId: NodeIds.insuredAddBeneficiary };
